export const MODAL_EASE = [0.22, 1, 0.36, 1];

export const MODAL_BACKDROP_CLASS = "bg-[#020614]/70";

export const DESKTOP_WORK_AREA_INSET_STYLE = {
  top: "15px",
  right: "15px",
  bottom: "15px",
  left: "calc(5rem + 15px)",
};

export const VAULT_DESKTOP_WORKSPACE_MODAL_STYLE = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

export const VAULT_DESKTOP_WORKSPACE_MODAL_Z_CLASS = "z-[70]";

export const VAULT_DESKTOP_WORKSPACE_SHEET_CLASS =
  "h-full w-[min(760px,calc(100%-48px))] overflow-hidden shadow-2xl";

export const DESKTOP_WORK_AREA_HORIZONTAL_INSET_STYLE = {
  left: DESKTOP_WORK_AREA_INSET_STYLE.left,
  right: DESKTOP_WORK_AREA_INSET_STYLE.right,
};

export const MODAL_PANEL_CLASS =
  "border border-white/58 bg-[linear-gradient(105deg,rgba(42,45,56,0.78)_0%,rgba(26,34,48,0.72)_48%,rgba(35,48,66,0.78)_100%)] text-white shadow-[0_24px_80px_rgba(0,0,0,0.36),inset_0_1px_0_rgba(255,255,255,0.10)] backdrop-blur-[18px]";

export const MODAL_MOBILE_MAX_HEIGHT =
  "calc(100dvh - var(--bottom-nav-clearance, 112px) - max(env(safe-area-inset-top), 16px) - 12px)";

export const MODAL_DEFAULT_DESKTOP_MAX_HEIGHT = "min(82vh, 720px)";

export const getModalPanelMaxHeightStyle = (
  isDesktop,
  desktopMaxHeight = MODAL_DEFAULT_DESKTOP_MAX_HEIGHT
) => ({
  maxHeight: isDesktop ? desktopMaxHeight : MODAL_MOBILE_MAX_HEIGHT,
});

export const modalPanelVariants = {
  hidden: {
    opacity: 0,
    y: 24,
    scale: 0.78,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.44,
      ease: MODAL_EASE,
      when: "beforeChildren",
      staggerChildren: 0.045,
    },
  },
  exit: {
    opacity: 0,
    y: 18,
    scale: 0.86,
    filter: "blur(6px)",
    transition: {
      duration: 0.24,
      ease: "easeInOut",
      when: "afterChildren",
      staggerChildren: 0.025,
      staggerDirection: -1,
    },
  },
};

export const modalBottomSheetVariants = {
  hidden: { opacity: 1, y: "100%", scale: 1 },
  visible: {
    opacity: 1, y: 0, scale: 1,
    transition: { duration: 0.42, ease: MODAL_EASE },
  },
  exit: {
    opacity: 1, y: "100%", scale: 1,
    transition: { duration: 0.3, ease: MODAL_EASE },
  },
};

export const modalContentRootVariants = {
  hidden: {},
  visible: {
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.045,
    },
  },
  exit: {
    transition: {
      when: "afterChildren",
      staggerChildren: 0.025,
      staggerDirection: -1,
    },
  },
};

export const appModalContentItemVariants = {
  hidden: {
    opacity: 0,
    y: 10,
    scale: 0.98,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.28,
      ease: MODAL_EASE,
    },
  },
  exit: {
    opacity: 0,
    y: 6,
    scale: 0.98,
    transition: {
      duration: 0.16,
      ease: "easeInOut",
    },
  },
};

export const modalBackdropVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.18, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    transition: { delay: 0.08, duration: 0.16, ease: "easeIn" },
  },
};
